import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

type Props = {
  title?: React.ReactNode;
  children?: React.ReactNode /* modal's body */;
  okButtonLabel?: React.ReactNode;
  cancelButtonLabel?: React.ReactNode;
  open: boolean;
  onClose: () => void;
  onOk?: (e: React.MouseEvent<HTMLElement>) => void;
};

const ConfirmDialog: React.FC<Props> = ({
  children,
  title = '最終確認',
  okButtonLabel = 'はい',
  cancelButtonLabel = 'いいえ',
  open = false,
  onClose = () => {},
  onOk = undefined,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelButtonLabel}</Button>
        {onOk && <Button onClick={onOk}>{okButtonLabel}</Button>}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
